import { colors, layout } from './../../../config/styles'

export default {
	container: {
		display 		: 'flex',
		justifyContent 	: 'space-between',
		alignItems 		: 'center',
		paddingTop 		: layout.outerGutter/2,
		paddingBottom 	: layout.outerGutter/2,
		paddingLeft 	: layout.outerGutter,
		paddingRight 	: layout.outerGutter,

		'@media (max-width: 450px)' : {
			display 		: 'block',
		}
	},
	//Logo
	brandLogoWrapper: {
		width 		: 150,
		fontSize 	: 0,

		'@media (max-width: 450px)' : {
			margin 		: '0px auto',
		}
	},
	logo: {
		width 	 	: '100%',
	},

	//Nav
	navContainer : {
		position			: 'relative',
		width				: '100%',
		height 				: '100%',
		display 			: 'flex',
		justifyContent 		: 'flex-end',
		flexDirection 		: 'column',
	},
	//OLD
	navUl : {
		display 			: 'flex',
		justifyContent 		: 'flex-end',
		flexDirection 		: 'row',
		alignItems 			: 'center',
		listStyle 			: 'none',
		padding 			: 0,

		'@media (max-width: 450px)' : {
			flexDirection 		: 'column',
		}
	},
	navLi : {
		textAlign			: 'center',
		paddingLeft 		: 30,
		fontSize			: 14,
		fontWeight 			: 300,
		textTransform 		: 'uppercase',

		'@media (max-width: 650px)' : {
			paddingLeft 	: 20,
			lineHeight 		: '60px',
			fontSize		: 12,
		},
		'@media (max-width: 550px)' : {
			paddingLeft 	: 16,
			fontSize		: 10,
		},
		'@media (max-width: 450px)' : {
			padding			: '10px 0px',
			fontSize		: 14,
			lineHeight 		: 1,
			display 		: 'none',
			width 			: '100%',
			borderBottom 	: `1px solid ${colors.lightGray}`,
		}
	},
	liOpen : {
		'@media (max-width: 450px)' : {
			display 	: 'block',
		}
	},
	link : {
		color 				: colors.black,
		textAlign			: 'center',
		textDecoration		: 'none',

		transition			: 'color 0.2s ease-in',

		':hover' : {
			color : colors.darkGray,
		},
		':active' : {
			color : colors.darkGray,
		},
	},
	mobileNavButton : {
		position			: 'absolute',
		top 				: 12,
		right 				: 10,
		width 				: 40,
		height 				: 40,
		borderRadius 		: 5,
		cursor 				: 'pointer',
		display 			: 'none',
		zIndex 				: 100,
		padding 			: 5,


		border 				: `1px solid ${colors.red}`,
		backgroundColor 	: colors.red,
		fill 				: colors.white,
		transition 			: 'background-color 0.2s ease-in, fill 0.2s ease-in, transform 0.3s ease-in-out',

		'@media (max-width: 450px)' : {
			display 		: 'block',
		}
	},
	navIcon : {
		width 			: '100%',
	},
	activeMobileNavButton : {
		transform 	: 'rotate(90deg)'
	}
}



// WEBPACK FOOTER //
// ./src/layout/Front/Navbar/styles.js